/** Hoy, con la hora en cero, para comparar fechas por día calendario. */
export function hoySinHora() {
  const h = new Date();
  return new Date(h.getFullYear(), h.getMonth(), h.getDate());
}

/** Combina Mes/Año del registro con su DiaCobro, ajustando al último día válido del mes (ej. 31 en un mes de 30 días). */
export function fechaCobroDe(g) {
  const ultimoDia = new Date(g.anio, g.mes, 0).getDate();
  const dia = Math.min(g.diaCobro, ultimoDia);
  return new Date(g.anio, g.mes - 1, dia);
}

/** Días de diferencia entre hoy y la fecha de cobro (negativo si ya venció). */
export function diasHastaVencer(g) {
  return Math.round((fechaCobroDe(g) - hoySinHora()) / 86400000);
}
